<!-- 弹窗组件 -->
<template>
    <div>
        <div
            class="pop-div"
            v-if="popValue && popData.content.style_value == 1"
        >
            <div
                class="btn-divs bg-div"
                :style="{
                    ...(popData.content.bg_color && {
                        backgroundColor: popData.content.bg_color,
                    }),
                    ...(popData.content.bg_img.picview &&
                        popData.content.bg_value && {
                            backgroundImage: `url(${popData.content.bg_img.picview})`,
                        }),
                    width: `${popData.content.bg_width}px`,
                    height: `${popData.content.bg_height}px`,
                    borderRadius: `${popData.content.radiusData.top}px ${popData.content.radiusData.top}px ${popData.content.radiusData.bottom}px ${popData.content.radiusData.bottom}px`,
                }"
            >
                <!-- 关闭方式 -->
                <!-- 右上 -->
                <img
                    class="del-img1"
                    v-if="
                        popData.content.cancel_value1 == 2 &&
                        popData.content.cancel_position_value1 == 1
                    "
                    src="@/assets/pop_close.png"
                    @click="closePop"
                />
                <!-- 正下 -->
                <img
                    class="del-img2"
                    v-if="
                        popData.content.cancel_value1 == 2 &&
                        popData.content.cancel_position_value1 == 2
                    "
                    src="@/assets/pop_close.png"
                    @click="closePop"
                />
                <!-- 正上 -->
                <img
                    class="del-img3"
                    v-if="
                        popData.content.cancel_value1 == 2 &&
                        popData.content.cancel_position_value1 == 3
                    "
                    src="@/assets/pop_close.png"
                    @click="closePop"
                />
                <!-- 默认 -->
                <Icon
                    class="del-img4"
                    v-if="popData.content.cancel_value1 == 3"
                    type="md-close"
                    size="22"
                    @click="closePop"
                />
                <div
                    class="mb12"
                    :style="`font-size: ${popData.content.title_size}px;color: ${popData.content.title_color};`"
                >
                    {{ popData.content.title }}
                </div>
                <div
                    :style="`width: 100%;padding: 0 12px;text-align: ${popData.content.text_position};font-size: ${popData.content.text_size}px;color: ${popData.content.text_color};`"
                >
                    {{ popData.content.text }}
                </div>
                <div class="w100">
                    <div
                        class="btn-div"
                        v-if="popData.content.btn_value == 2"
                        @click="closePop"
                        :style="`color: ${popData.content.txt_color}; margin: 24px ${popData.content.btnData.left}px 0 ${popData.content.btnData.left}px;
                            background-color: ${popData.content.btn_bg_color}; border: 1px solid ${popData.content.btn_border_color}; border-radius: ${popData.content.btnData.radius}px;
                        `"
                    >
                        {{ popData.content.btn_text }}
                    </div>
                </div>
                <div
                    class="ai-c w100"
                    v-if="popData.content.btn_value == 3"
                    :style="`padding: 24px ${popData.content.btnData.left}px 0 ${popData.content.btnData.left}px;`"
                >
                    <div
                        class="btn-div wh100"
                        @click="closePop"
                        :style="`color: ${popData.content.txt_color2};
                            background-color: ${popData.content.btn_bg_color2}; border: 1px solid ${popData.content.btn_border_color2}; border-radius: ${popData.content.btnData.radius}px;
                        `"
                    >
                        {{ popData.content.btn_text2 }}
                    </div>
                    <div
                        class="btn-div wh100 pt-6 pb-6"
                        @click="closePop"
                        :style="`margin-left: 12px;color: ${popData.content.txt_color};
                            background-color: ${popData.content.btn_bg_color}; border: 1px solid ${popData.content.btn_border_color}; border-radius: ${popData.content.btnData.radius}px;
                        `"
                    >
                        {{ popData.content.btn_text }}
                    </div>
                </div>
            </div>
        </div>
        <!-- 全屏广告 -->
        <div
            class="content"
            v-if="popValue && popData.content.style_value == 2"
        >
            <!-- 按钮 -->
            <img
                class="countdown-div1"
                v-if="
                    popData.content.bg_img.picview &&
                    popData.content.cancel_value2 == 2 &&
                    popData.content.cancel_position_value2 == 1
                "
                src="@/assets/pop_close.png"
                @click="closePop"
            />
            <img
                class="countdown-div2"
                v-if="
                    popData.content.bg_img.picview &&
                    popData.content.cancel_value2 == 2 &&
                    popData.content.cancel_position_value2 == 2
                "
                src="@/assets/pop_close.png"
                @click="closePop"
            />
            <img
                class="countdown-div3"
                v-if="
                    popData.content.bg_img.picview &&
                    popData.content.cancel_value2 == 2 &&
                    popData.content.cancel_position_value2 == 3
                "
                src="@/assets/pop_close.png"
                @click="closePop"
            />
            <img
                class="countdown-div4"
                v-if="
                    popData.content.bg_img.picview &&
                    popData.content.cancel_value2 == 2 &&
                    popData.content.cancel_position_value2 == 4
                "
                src="@/assets/pop_close.png"
                @click="closePop"
            />
            <!-- 倒计时 -->
            <!-- 左上 -->
            <div
                class="countdown-div1"
                v-if="
                    popData.content.bg_img.picview &&
                    popData.content.cancel_value2 == 3 &&
                    popData.content.cancel_position_value2 == 1
                "
                @click="closePop"
                :style="`
                    background-color: ${
                        popData.content.countdown_bg_color
                    }; color: ${
                    popData.content.countdown_text_color
                }; opacity: ${popData.content.countdown_opacity * 0.01};
                `"
            >
                {{ popData.content.countdown }}s | 跳过
            </div>
            <!-- 右上 -->
            <div
                class="countdown-div2"
                v-if="
                    popData.content.bg_img.picview &&
                    popData.content.cancel_value2 == 3 &&
                    popData.content.cancel_position_value2 == 2
                "
                @click="closePop"
                :style="`
                    background-color: ${
                        popData.content.countdown_bg_color
                    }; color: ${
                    popData.content.countdown_text_color
                }; opacity: ${popData.content.countdown_opacity * 0.01};
                `"
            >
                {{ popData.content.countdown }}s | 跳过
            </div>
            <!-- 左下 -->
            <div
                class="countdown-div3"
                v-if="
                    popData.content.bg_img.picview &&
                    popData.content.cancel_value2 == 3 &&
                    popData.content.cancel_position_value2 == 3
                "
                @click="closePop"
                :style="`
                    background-color: ${
                        popData.content.countdown_bg_color
                    }; color: ${
                    popData.content.countdown_text_color
                }; opacity: ${popData.content.countdown_opacity * 0.01};
                `"
            >
                {{ popData.content.countdown }}s | 跳过
            </div>
            <!-- 右下 -->
            <div
                class="countdown-div4"
                v-if="
                    popData.content.bg_img.picview &&
                    popData.content.cancel_value2 == 3 &&
                    popData.content.cancel_position_value2 == 4
                "
                @click="closePop"
                :style="`
                    background-color: ${
                        popData.content.countdown_bg_color
                    }; color: ${
                    popData.content.countdown_text_color
                }; opacity: ${popData.content.countdown_opacity * 0.01};
                `"
            >
                {{ popData.content.countdown }}s | 跳过
            </div>
            <!-- 背景图 -->
            <img
                class="wh100"
                v-if="popData.content.bg_img.picview"
                :src="popData.content.bg_img.picview"
            />
            <div v-else class="none-div">请上传图片~</div>
            <!-- 按钮设置 -->
            <div
                class="position-absolute"
                v-if="popData.content.bg_img.picview"
                :style="`padding: 0 ${popData.content.btnData.left}px;`"
            >
                <div
                    class="btn-div wh100"
                    v-if="popData.content.btn_value == 2"
                    :style="`color: ${popData.content.txt_color};
                        background-color: ${popData.content.btn_bg_color}; border: 1px solid ${popData.content.btn_border_color}; border-radius: ${popData.content.btnData.radius}px;
                    `"
                    @click="closePop"
                >
                    {{ popData.content.btn_text }}
                </div>
                <div class="ai-c" v-if="popData.content.btn_value == 3">
                    <div
                        class="btn-div wh100"
                        :style="`color: ${popData.content.txt_color2};
                            background-color: ${popData.content.btn_bg_color2}; border: 1px solid ${popData.content.btn_border_color2}; border-radius: ${popData.content.btnData.radius}px;
                        `"
                        @click="closePop"
                    >
                        {{ popData.content.btn_text2 }}
                    </div>
                    <div
                        class="btn-div wh100"
                        :style="`margin-left: 12px;color: ${popData.content.txt_color};
                            background-color: ${popData.content.btn_bg_color}; border: 1px solid ${popData.content.btn_border_color}; border-radius: ${popData.content.btnData.radius}px;
                        `"
                        @click="closePop"
                    >
                        {{ popData.content.btn_text }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        popData: {
            type: Object,
            default: {},
        },
        popValue: {
            type: Boolean,
            default: false,
        },
        showMask: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        closePop() {
            this.$emit("update:popValue", false);
            this.$emit("update:showMask", false);
        },
    },
};
</script>

<style scoped>
.pop-div {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: gray;
}
.btn-div {
    padding: 6px 0;
    font-size: 16px;
    text-align: center;
}
.ai-c {
    display: flex;
    align-items: center;
}
.content2 {
    position: absolute;
    top: 200px;
    left: 37.5px;
    right: 37.5px;
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6);
    z-index: 1000;
}
.countdown-div {
    padding: 0 6px;
    border-radius: 10px;
    position: absolute;
    top: -188px;
    left: -24px;
}
.del-img1 {
    position: absolute;
    top: -40px;
    right: 0;
    width: 30px;
    height: 30px;
}
.del-img2 {
    position: absolute;
    bottom: -40px;
    left: calc(50% - 15px);
    width: 30px;
    height: 30px;
}
.del-img3 {
    position: absolute;
    top: -40px;
    left: calc(50% - 15px);
    width: 30px;
    height: 30px;
}
.del-img4 {
    position: absolute;
    top: 12px;
    right: 12px;
}
.position-absolute {
    position: absolute;
    bottom: 55px;
    left: 0;
    width: 100%;
}
.content {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background-color: gray;
}
.countdown-div1 {
    padding: 0 6px;
    position: absolute;
    top: 12px;
    left: 12px;
    border-radius: 12px;
}
.countdown-div2 {
    padding: 0 6px;
    position: absolute;
    top: 12px;
    right: 12px;
    border-radius: 12px;
}
.countdown-div3 {
    padding: 0 6px;
    position: absolute;
    bottom: 12px;
    left: 12px;
    border-radius: 12px;
}
.countdown-div4 {
    padding: 0 6px;
    position: absolute;
    bottom: 12px;
    right: 12px;
    border-radius: 12px;
}
.wh100 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.pt-6 {
    padding-top: 6px;
}
.pb-6 {
    padding-bottom: 6px;
}
.btn-divs {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}
.w100 {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
}
.none-div {
    font-size: 14px;
    color: #ccc;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
</style>